<template>
  <div v-if="isReady">
    <div v-if="canRegister" class="sf-std-content">
      <RegisterIndividual
        v-if="type == 'individual'"
        :mf-token-data="mfTokenData"
      />
      <RegisterSchool
        v-else-if="type == 'school'"
        :mf-token-data="mfTokenData"
      />
      <AccountTypeSelect v-else />
    </div>
    <div v-else-if="mfToken">
      <div v-if="mfTokenData?.error == 'mfUserMoved'">
        <MfJoinError :error="mfTokenData?.error">
          It is not possible to complete this action.
        </MfJoinError>
      </div>
      <div v-else-if="mfTokenData?.error == 'invalidUser'">
        <div class="tw-text-2xl tw-text-danger tw-font-bold">Invalid User</div>
        <p>You are logged in as a user for whom this link is not valid.</p>
        <p>Please logout and try the link again.</p>
      </div>
      <div v-else>
        <div class="tw-text-2xl tw-text-danger tw-font-bold">
          <template v-if="mfTokenData?.error == 'expiredMfToken'"
            >Expired</template
          ><template v-else>Invalid</template> Link
        </div>
        <p>
          To generate a new link
          <SfRouterLink v-if="$currentUser.value" to="/mf/join-sf"
            >click here</SfRouterLink
          ><span v-else
            >please login with your Mathsframe credentials and follow the
            instructions in your dashboard</span
          >.
        </p>
        <p>Or <ContactLink /> for further assistance.</p>
      </div>
    </div>
    <div v-else class="tw-text-center tw-py-10">
      You are already logged in. If you want to create a new account please
      logout first.
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AccountTypeSelect from "@/components/register/AccountTypeSelect.vue";
import RegisterIndividual from "@/components/register/RegisterIndividual.vue";
import RegisterSchool from "@/components/register/RegisterSchool.vue";
import apiCall from "@/func/net/apiCall";
import ContactLink from "../ui/ContactLink.vue";
import SfRouterLink from "../shared/SfRouterLink.vue";
import { MfTokenData } from "@/types/mfTypes";
import MfJoinError from "../mathsframe/MfJoinError.vue";

export default defineComponent({
  components: {
    RegisterIndividual,
    RegisterSchool,
    AccountTypeSelect,
    MfJoinError,
    SfRouterLink,
    ContactLink,
  },
  data() {
    return {
      isReady: false,
      mfTokenData: null as MfTokenData | null,
    };
  },
  computed: {
    type(): "individual" | "school" | null {
      const param = this.$route.params["type"];
      return param ? (param as "individual" | "school") : null;
    },
    mfToken() {
      return this.$route.query.mft || null;
    },
    canRegister() {
      if (this.mfToken) {
        if (this.mfTokenData?.isValid) {
          return true;
        }
      } else if (!this.$currentUser.value) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (this.mfToken) {
      this.validateMfToken();
    } else {
      this.isReady = true;
    }
  },
  methods: {
    async validateMfToken() {
      this.mfTokenData = null;
      const data = await apiCall("mf-sf-account/validate-token", {
        t: this.mfToken,
      });
      if (data.success) {
        this.mfTokenData = data.data as MfTokenData;
        this.isReady = true;
      }
    },
  },
});
</script>
